import { render, staticRenderFns } from "./Backendgroup.vue?vue&type=template&id=35457ac0"
import script from "./Backendgroup.vue?vue&type=script&lang=js"
export * from "./Backendgroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports